
<template>
    <div>
        <a class="btn btn-sm btn-alt-info me-1" v-on:click="modal.show()">
            <i class="fa fa-fw fa-envelope"></i> Send Email
        </a>
        <div ref="modal" class="modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <form class="modal-content" v-on:submit.prevent="submit">
                    <div>
                        <div class="block block-rounded block-transparent mb-0">
                            <div class="block-header block-header-default">
                                <h3 class="block-title">Send Invoice {{invoice.number}}</h3>
                                <div class="block-options">
                                </div>
                            </div>
                        </div>
                        <div class="block-content fs-sm">
                            <div class="mb-4">
                                <label class="form-label" for="f_email_addresses">Email Address</label>
                                <select class="form-select" id="f_email_addresses" ref="emailSelect" multiple v-model="email_addresses">
                                    <option v-for="(email_address, index) in email_addresses" selected :value="email_address">
                                        {{email_address}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="block-content block-content-full text-end bg-body">
                            <button type="button" class="btn btn-sm btn-alt-secondary me-1"
                                data-bs-dismiss="modal">Close</button>
                            <button class="btn btn-sm btn-primary me-1">
                                <i class="fa fa-fw fa-paper-plane"></i> Send Email
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';

export default {
    props: {
        invoice: {
            type: Object,
            required: true,
        },
        customer: {
            type: Object,
            required: true,
        },
        routes: Object
    },
    data() {
        return {
            email_addresses: [],
        };
    },
    mounted() {
        this.modal = new Modal(this.$refs.modal);
        if (this.customer.email) {
            this.email_addresses.push(this.customer.email);
        }
        this.emailSelect = window.jQuery('#f_email_addresses').select2({
            placeholder: 'Select Email Address(es)',
            width: "100%",
            multiple: true,
            tags: true,
        });
    },
    methods: {
        submit () {
            this.modal.hide();
            axios.post(this.routes.emailInvoiceRoute, {
                recipients: this.emailSelect.val()
            }).then((response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Invoice sent to recipients',
                    showConfirmButton: true,
                });
            }).catch((error) => {
                const code = error.response.status;
                if (code === 422) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid email address entered, please check and try again',
                    });
                } else if (code === 500) {
                    Swal.fire({
                        icon: 'error',
                        title: 'System error, contact support'
                    })
                }
            });
        }
    },
}
</script>